module.exports = __webpack_public_path__ + "static/logo-white.bbc120ed.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/logo-white.svg
// module id = 44
// module chunks = 34471704633725 181753073384772 216468464745311